// extracted by mini-css-extract-plugin
module.exports = {"container":"Incident_container__3mh26","page":"Incident_page__26Gd5","section":"Incident_section__15ZuJ"};